import { format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { es } from 'date-fns/locale';
import { TYPE_MOVEMENT } from '../../helpers/enums';
import { BRANDING } from '../../config/branding';

const zonaHoraria = 'America/Buenos_Aires';
const fechaEnZonaHoraria = (date) => utcToZonedTime(parseISO(date), zonaHoraria);
const FechaFormateada = (date) => format(fechaEnZonaHoraria(date), "PPPP", { timeZone: zonaHoraria, locale: es });
const movementColors = BRANDING.movementColors || {};

const getColorFontRow = (row) => {
    var color = ''
    switch(row.type) {
      case TYPE_MOVEMENT.INVERSION:
        color = movementColors.inversionText
        break;
      case TYPE_MOVEMENT.REINVERSION:
        color = movementColors.reinversionText
        break;
      case TYPE_MOVEMENT.GASTO:
      case TYPE_MOVEMENT.DEVOLUCION:
        color = movementColors.expenseText
        break;
      case TYPE_MOVEMENT.VENTA:
      case TYPE_MOVEMENT.DINERO_DISPONIBLE:
        color = movementColors.saleText
        break;
      case TYPE_MOVEMENT.DINERO_DISPONIBLE_PARA_REINVERSION:
        color = movementColors.reinversionText
        break;
      default:
        break;
    }
    return color;
  }

  const getColorRow = (row) => {
    var background = ''
    switch(row.type) {
      case TYPE_MOVEMENT.INVERSION:
        background = movementColors.inversionBg
        break;
      case TYPE_MOVEMENT.REINVERSION:
        background = movementColors.reinversionBg
        break;
      case TYPE_MOVEMENT.GASTO:
      case TYPE_MOVEMENT.DEVOLUCION:
        background = movementColors.expenseBg
        break;
      case TYPE_MOVEMENT.VENTA:
        background = movementColors.saleBg
        break;
      case TYPE_MOVEMENT.DINERO_DISPONIBLE:
        background = movementColors.availableBg
        break;
      case TYPE_MOVEMENT.DINERO_DISPONIBLE_PARA_REINVERSION:
        background = movementColors.reinversionBg
        break;
      default:
        break;
    }
    return background;
  }

export {
    getColorFontRow,
    getColorRow,
    FechaFormateada
}